"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceSelectCard = void 0;
const globals_1 = require("@app/const/globals");
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
require("./style.scss");
const COLORS = {
    DEFAULT: 'default',
    DARK: 'dark',
    PRIMARY: 'primary',
};
const TYPES = {
    ORGANIZATIONS: 'organizations',
    WORKSPACES: 'workspaces',
};
const WorkspaceSelectCard = ({ color, onClick, isSelected, data, isLoading, userId, }) => {
    const textColor = color === COLORS.DEFAULT ? COLORS.DEFAULT : 'white';
    const enforcedLocality = util_1.miscUtil.getEnforcedLocality();
    const [selectedLocality, setSelectedLocality] = (0, react_1.useState)(data.enforceLocalities && data.localities?.length
        ? enforcedLocality && data.localities?.some((l) => l.id === enforcedLocality)
            ? enforcedLocality
            : enforcedLocality === globals_1.NO_LOCALITY
                ? globals_1.NO_LOCALITY
                : data.localities[0].id
        : null);
    const optsLocalities = data.enforceLocalities && data.localities?.length
        ? data.localities
            .map((l) => {
            return {
                value: l.id,
                label: react_1.default.createElement(_ui_1.Locality, { ...l, variant: 'shortName' }),
            };
        })
            .filter((loc) => {
            // if this WS has enforcedLocalities, we filter out some locality options
            if (data.enforceLocalities) {
                const myLocalities = data.localities?.filter((l) => l?.assigns?.some((ass) => ass.userId === userId)) || [];
                if (myLocalities.length === 0) {
                    // if we have 0 localities, we treat it as if we had all of them and leave them all in
                    return true;
                }
                else {
                    // if we have more than 0 localities, we leave the ones that we have
                    return myLocalities.some((ml) => ml.id === loc.value);
                }
            }
            return true;
        })
            .concat({
            value: globals_1.NO_LOCALITY,
            label: (0, util_1.t)('GLOBAL_NO_LOCALITY'),
        })
        : [];
    const isOrg = data.type === TYPES.ORGANIZATIONS;
    return (react_1.default.createElement("div", { "data-testid": `workspace-select-card-${data.id}`, className: (0, classnames_1.default)('ds-ws-card', color) },
        react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN, align: _ui_1.Flex.POSITION.CENTER, justify: _ui_1.Flex.POSITION.CENTER },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('ds-ws-card-avatar', textColor) }, isLoading ? react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.loader }) : data.shortcut),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16 }),
            react_1.default.createElement("div", { className: 'ds-ws-card-name', style: { color: isOrg ? _ui_1.Text.COLORS.WHITE : _ui_1.Text.COLORS.BLACK } }, data.name),
            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE, color: isOrg ? _ui_1.Text.COLORS.GRAY_LIGHT : _ui_1.Text.COLORS.GRAY, align: _ui_1.Text.ALIGN.CENTER }, isOrg
                ? (0, util_1.t)('ORGANIZATIONS')
                : !isLoading && data.customId
                    ? `ID ${data.customId}`
                    : ' ')),
        isSelected && (!data.enforceLocalities || !data.localities?.length) ? (react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.ROW, stretch: true, align: _ui_1.Flex.POSITION.CENTER, justify: _ui_1.Flex.POSITION.CENTER },
            react_1.default.createElement(_ui_1.Text, { color: isOrg ? _ui_1.Text.COLORS.WHITE : _ui_1.Text.COLORS.PRIMARY },
                react_1.default.createElement(_ui_1.Flex, null,
                    react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.check }),
                    (0, util_1.t)('WS_SETTINGS_CARD_CURRENTLY_SELECTED'))))) : (react_1.default.createElement(_ui_1.Flex, { stretch: true, justify: _ui_1.Flex.POSITION.CENTER },
            data.enforceLocalities && data.localities?.length && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(_ui_1.Dropdown, { searchable: true, sortedOptions: true, singleSelect: true, size: _ui_1.Dropdown.SIZES.FULL_WIDTH, type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.LIGHT, options: optsLocalities, value: optsLocalities.filter((opt) => opt.value === selectedLocality), placeholder: (0, util_1.t)('SELECT'), onChange: (vp) => {
                        setSelectedLocality(vp.value);
                    } }),
                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_6 }))),
            react_1.default.createElement(_ui_1.Button, { onClick: () => {
                    onClick(selectedLocality || undefined);
                }, disabled: data.enforceLocalities &&
                    !!data.localities?.length &&
                    optsLocalities.filter((opt) => opt.value === selectedLocality)
                        .length === 0, size: _ui_1.Button.SIZES.LARGE, label: (0, util_1.t)('ENTER'), color: data.type === TYPES.ORGANIZATIONS
                    ? _ui_1.Button.COLORS.WHITE
                    : _ui_1.Button.COLORS.PRIMARY, bold: true })))));
};
exports.WorkspaceSelectCard = WorkspaceSelectCard;
exports.WorkspaceSelectCard.defaultProps = {
    color: COLORS.DEFAULT,
    onClick: () => { },
    isSelected: false,
};
exports.WorkspaceSelectCard.COLORS = COLORS;
